export type BuyerOfferPanelTarget = {
  offerId?: string;
  listingId?: string | null;
  entryId?: string;
  targetUserId?: string;
};

export const buyerOfferPanelQuery = ({
  offerId,
  listingId,
  entryId,
  targetUserId,
}: BuyerOfferPanelTarget) =>
  listingId
    ? { buyerListing: listingId, buyerOfferId: offerId }
    : { buyerOffer: entryId, buyerOfferId: offerId, target: targetUserId };

export const sellerOfferPanelQuery = ({
  offerId,
  entryId,
}: {
  offerId?: string;
  entryId?: string;
}) => ({ entry: entryId, sellerOfferId: offerId });
